import { render, staticRenderFns } from "./CampStudents.vue?vue&type=template&id=65a49e3a&"
import script from "./CampStudents.vue?vue&type=script&lang=js&"
export * from "./CampStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports